var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotCircle = function SvgDotCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    fill: "none",
    role: "presentation"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 75,
    fill: "#000",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 136,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 28
  })));
};
export default SvgDotCircle;